import { useNavigate } from "react-router-dom";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import TableComponent from "../../Components/Comman/TableComponent";
import { useEffect, useState } from "react";
import Pagination from "../../Components/Comman/Pagination";
import { useSelector } from "react-redux";
import { CLIENT } from "../../constants/roles";
import { toast } from "react-toastify";
import { useSearch } from "../../context/SearchContext";
import { ProjectService } from "../../services/ProjectService";
import { usePagination } from "../../hooks/usePagination";
import MobileClientProjects from "./MobileClientProjects"; 

const ClientProjects = () => {
  const navigate = useNavigate();
  const userRole = useSelector((state) => state?.auth?.user?.role);
  const { debounceSearchTerm } = useSearch();
  const [projectList, setProjectList] = useState([]);
  const { currentPage, totalPages, goToPage, setTotalPages } = usePagination();

  // Fetch Projects
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await ProjectService.getProjectList(
          currentPage,
          10,
          debounceSearchTerm
        );
        if (data) {
          setProjectList(data.data);
          setTotalPages(data.pagination.totalPages);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };

    fetchProjects();
  }, [currentPage, debounceSearchTerm, setTotalPages]);

  const projectColumn = [
    {
      label: "Id",
      field: "id",
      headerClassName:
        "text-left pl-2 border-l border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-l border-[#d3cccc] w-[10%]",
    },
    {
      label: "Project Name",
      field: "projectName",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 w-[50%]",
    },
    {
      label: "Client Name",
      field: "clientName",
      headerClassName: `text-left pl-2 border-t border-b border-[#d3cccc] w-[15%] ${
        userRole === CLIENT ? "hidden" : ""
      }`,
      className: `text-[15px] text-left pl-2 ${
        userRole === CLIENT ? "hidden" : ""
      }`,
    },
    {
      label: "Vendor Client Name",
      field: "vendorClientName",
      headerClassName: `text-left pl-2 border-t border-b border-[#d3cccc] w-[15%] ${
        userRole === CLIENT ? "hidden" : ""
      }`,
      className: `text-[15px] text-left pl-2 ${
        userRole === CLIENT ? "hidden" : ""
      }`,
    },
    {
      label: "View Details",
      field: "view",
      headerClassName: "border-r border-t border-b border-[#d3cccc]",
      className: "border-r border-[#d3cccc] w-[10%]",
      render: (item) => (
        <div
          onClick={() =>
            navigate(`/client-project-details/${item.id}`, {
              state: { projectName: item?.projectName },
            })
          }
          className="flex justify-center items-center"
        >
          <MdOutlineRemoveRedEye className="w-5 h-5" />
        </div>
      ),
    },
  ];

  return (
    <section className="p-4">
      <div className="bg-white p-4 shadow-md rounded-[4px]">
        {/* ================= DESKTOP TABLE ================= */}
        <div className="hidden md:block">
          <TableComponent
            columns={projectColumn}
            data={projectList}
            headerBg={"bg-[#f6f6f6]"}
          />
        </div>

        {/* ================= MOBILE CARDS ================= */}
        <div className="block md:hidden">
          <MobileClientProjects
            projects={projectList}
            onView={(project) =>
              navigate(`/client-project-details/${project.id}`, {
                state: { projectName: project?.projectName },
              })
            }
          />
        </div>

        <br />
        {projectList.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            goToPage={goToPage}
          />
        )}
      </div>
    </section>
  );
};

export default ClientProjects;
